module.exports = __webpack_public_path__ + "static/media/Icon_My_Account.bfbf52e6.svg";